import { Inject, Injectable } from '@rxdi/core';
import { BehaviorSubject, from, isObservable, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { TranslationsConfig } from './translate.config';

@Injectable()
export class TranslateService {
  currentLanguage: BehaviorSubject<string> = new BehaviorSubject(localStorage.getItem('lang') || 'EN');

  @Inject(TranslationsConfig)
  config: TranslationsConfig;

  get(value: string) {
    const translations = this.config.translations || {};
    const record = translations[this.currentLanguage.getValue()];
    return (isObservable(record) || record instanceof Promise ? from(record) : of(record)).pipe(
      map((record) => record[value]),
      map((key) => key ?? value),
      catchError(() => value)
    );
  }

  changeLanguage(language: string): void {
    this.currentLanguage.next(language);
    localStorage.setItem('lang', language);
  }
}
